import { render } from "./ApprovalsList.vue?vue&type=template&id=1d6d04ae"
import script from "./ApprovalsList.vue?vue&type=script&lang=js"
export * from "./ApprovalsList.vue?vue&type=script&lang=js"

import "./ApprovalsList.vue?vue&type=style&index=0&id=1d6d04ae&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__